module.exports = __webpack_public_path__ + "img/Proliferation-OVCA_GSE227019.dc10aafc.png";